import { createSlice } from '@reduxjs/toolkit'

export type TypeUser = {
    idutente: number | null, 
    token: string | null, 
    username: string | null, 
    nome: string | null, 
    email: string | null, 
    idazienda: number | null,
    tipoutente: 'I' | 'C' | null,
    presenzecantieri: Array<string> 
}

type userAction = {
    type: string; 
    payload: TypeUser
}

const initialState = {
  idutente: null,
  token: null,
  username: null, 
  nome: null, 
  email: null,
  idazienda: null,
  tipoutente: null,
  presenzecantieri: []
}

export const counterSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    setUser: (state: TypeUser, action: userAction) => {
      state.idutente = action.payload.idutente; 
      state.token = action.payload.token;
      state.username = action.payload.username;
      state.nome = action.payload.nome; 
      state.email = action.payload.email;
      state.idazienda = action.payload.idazienda;
      state.tipoutente = action.payload.tipoutente;
      state.presenzecantieri = action.payload.presenzecantieri; // lista dei cantieri abilitati
    },
    logoutAction: (state: TypeUser) => {
        state = initialState;
    },
  },
})

export const { setUser, logoutAction } = counterSlice.actions

export default counterSlice.reducer